import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Timestamp, deleteDoc, doc, getDoc, updateDoc } from 'firebase/firestore';
import { format } from 'date-fns';
import { fr } from "date-fns/locale";
import { FaArrowLeft } from 'react-icons/fa6';
import { BsCheck2Circle } from 'react-icons/bs';
import { MdOutlineSmsFailed } from 'react-icons/md';
import { db } from '../../../firebase';
import Modal from '../../../components/Modal/Modal';
import { motion } from 'framer-motion';


function BlogArticleView() {

    const { id } = useParams();
    const [article, setArticle] = useState([]);
    const [isVisible, setIsVisible] = useState('');
    const [isDone, setIsDone] = useState(false);

    //read this article data
    useEffect(() => {
        const readThisArticleData = async () => {
            const docRef = doc(db, 'articles', id);
            const docSnap = await getDoc(docRef);
            setArticle(docSnap.data());
            setIsVisible(docSnap.data().isVisible);
        };
        readThisArticleData();
    }, [id]);

    const articleCover = { backgroundImage: `url(${article?.coverUrl})` };

    //Archiver un article
    const [isArchiving, setIsArchiving] = useState(false);

    const archivateArticle = async (event) => {
        event.preventDefault();
        setIsArchiving(true); // Afficher le loader

        const articleDocRef = doc(db, 'articles', id);

        try {
            // Attendre la mise à jour de l'article
            await updateDoc(articleDocRef, {
                isVisible: false,
                lastModif: Timestamp.now(),
            });

            // La mise à jour de l'article est réussie, nous pouvons réinitialiser setIsArchiving
            setIsArchiving(false);
            navigate(-1);
        } catch (error) {
            setIsArchiving(false);
            console.error("Error updating article: ", error);
            // Vous pouvez ajouter une logique de gestion d'erreur ici, comme afficher un message d'erreur à l'utilisateur.
        }
    };

    //Désarchiver un article
    const [isDisarchiving, setIsDisarchiving] = useState(false);

    const desarchivateArticle = async (event) => {
        event.preventDefault();
        setIsDisarchiving(true); // Afficher le loader

        const articleDocRef = doc(db, 'articles', id);

        try {
            // Attendre la mise à jour de l'article
            await updateDoc(articleDocRef, {
                isVisible: true,
                lastModif: Timestamp.now(),
            });

            // La mise à jour de l'article est réussie, nous pouvons réinitialiser setIsArchiving
            setIsDisarchiving(false);
            navigate(-1);
        } catch (error) {
            setIsDisarchiving(false);
            console.error("Error updating article: ", error);
            // Vous pouvez ajouter une logique de gestion d'erreur ici, comme afficher un message d'erreur à l'utilisateur.
        }
    };

    const deleteArticle = async () => {
        try {

            // Accédez au document dans Firestore
            const docRef = doc(db, 'articles', id);

            // Supprimez le document
            await deleteDoc(docRef);
            setIsDone(true);
            setOpen(true);

            // Vous pouvez également effectuer d'autres actions après la suppression, comme rediriger l'utilisateur ou afficher un message de confirmation.
        } catch (error) {
            setIsDone(false);
            setOpen(true);
            // Gérez l'erreur, par exemple en affichant un message d'erreur à l'utilisateur.
        }
    };

    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
        navigate(-1);
    }

    const containerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: 'easeOut',
                when: "beforeChildren",
                staggerChildren: 0.2,
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 }
    };

    const [author, setAuthor] = useState(null); // ou [] si tu préfères un tableau

    useEffect(() => {
        const fetchAuthor = async () => {
            try {
                const docRef = doc(db, "authors", article?.author);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setAuthor(docSnap.data()); // 👈 les données du document !
                } else {
                    console.log("Auteur introuvable.");
                }
            } catch (error) {
                console.error("Erreur lors du fetch de l'auteur :", error);
            }
        };

        if (article?.author) fetchAuthor();
    }, [article?.author]);

    if (!author) return (
        <div className="fixed inset-0 flex items-center justify-center bg-black z-[51]">
            <div className="w-16 h-16 border-8 border-white border-t-transparent rounded-full animate-spin" />
        </div>
    );

    return (
        <div className="xl:px-[60px]">
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6 }}
                className="flex flex-col items-center justify-center xl:gap-[100px] gap-[20px] lg:p-[5rem] lg:pb-[100px] pb-[80px] min-h-screen bg-black w-full"
            >
                <div className="flex flex-col xl:max-w-[1440px] w-full lg:gap-5 gap-[100px]">


                    <div className="flex flex-col gap-10 w-full px-[1.25rem]">

                        <button
                            onClick={() => navigate(-1)}
                            className="text-white text-[20px] hover:opacity-70 transition"
                            title="Retour"
                        >
                            <FaArrowLeft />
                        </button>

                        <div className="flex lg:flex-row flex-col gap-10 ">
                            <div className="flex flex-col gap-5 lg:w-2/5 ">
                                <motion.div
                                    initial={{ scale: 0.95, opacity: 0 }}
                                    animate={{ scale: 1, opacity: 1 }}
                                    transition={{ duration: 0.6 }}
                                    className="w-full bg-cover bg-center rounded-md lg:h-[65dvh] h-[55dvh] max-h-[600px] glow-animated shadow-xl shadow-slate-900"
                                    style={articleCover}
                                />

                            </div>


                            <motion.div
                                initial={{ x: 50, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                transition={{ duration: 0.8 }}
                                className="flex flex-col lg:w-3/5 gap-[30px]"
                            >
                                <div className="flex flex-col gap-5">

                                    <motion.div
                                        className="flex gap-[30px] overflow-x-scroll"
                                        initial="hidden"
                                        animate="visible"
                                        variants={{
                                            hidden: { opacity: 0, y: 20 },
                                            visible: {
                                                opacity: 1,
                                                y: 0,
                                                transition: {
                                                    duration: 0.6,
                                                    ease: 'easeOut',
                                                    when: "beforeChildren",
                                                    staggerChildren: 0.2,
                                                }
                                            }
                                        }}
                                    >
                                        {Array.isArray(article?.rubriques) && article.rubriques.length > 0 ? (
                                            article.rubriques.map((rubrique, index) => (
                                                <motion.p
                                                    key={index}
                                                    className="text-black bg-yellow ppmori font-bold rounded-md px-5 py-2.5"
                                                    initial={{ opacity: 0, y: 10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    variants={{
                                                        hidden: { opacity: 0, y: 20 },
                                                        visible: { opacity: 1, y: 0 }

                                                    }}
                                                >
                                                    {rubrique}
                                                </motion.p>
                                            ))
                                        ) : (
                                            <p className="text-white">Aucune rubrique disponible</p>
                                        )}
                                    </motion.div>

                                    <motion.p
                                        className="ppmori xl:text-[36px] text-[20px] text-white font-bold"
                                        initial={{ opacity: 0, y: 10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 0.2 }}
                                    >
                                        {article?.title}
                                    </motion.p>

                                    <motion.div
                                        className="flex lg:flex-row flex-col w-full lg:items-center gap-5 justify-between"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ delay: 0.3 }}
                                    >
                                        <div className="flex gap-2 items-center text-grey">
                                            <div className="h-9 w-9 rounded-full bg-cover bg-center"
                                                style={{ backgroundImage: `url(${author.profilPicture})` }} />
                                            <p className="flex gap-2">
                                                <span>by</span> {author.displayName}
                                            </p>
                                            -
                                            <p>{article?.createdAt && format(article.createdAt.toDate(), 'dd MMMM yyyy', { locale: fr })}</p>
                                        </div>


                                    </motion.div>

                                    <motion.p
                                        className="ppmori xl:text-[20px] text-[20px] text-white text-justify article-text-content"
                                        dangerouslySetInnerHTML={{ __html: article?.content }}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ delay: 0.4 }}
                                    />
                                </div>
                            </motion.div>
                        </div>
                    </div>


                </div>
            </motion.div>

            <div className="flex gap-5 fixed bottom-10 right-[30px] ">
                <Link to={"/dashboard/blogapp/edit/" + id} className='buttonblack'>Modifier l'article</Link>

                {isVisible ? (
                    <button
                        onClick={archivateArticle}
                        className='buttonblack'
                        type='button'
                    >
                        {isArchiving ? (
                            <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        ) : (
                            <p>Archiver</p>
                        )}
                    </button>

                ) : (

                    <button
                        onClick={desarchivateArticle}
                        className='buttonblack'
                        type='button'
                    >
                        {isDisarchiving ? (
                            <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        ) : (
                            <p>Désarchiver</p>
                        )}
                    </button>
                )}

                {isVisible === false && (
                    <button
                        className='buttonblack'
                        type='button'
                        onClick={() => {
                            const confirmDelete = window.confirm("Es-tu sûr de vouloir supprimer cet article ? Cette action est irréversible.");
                            if (confirmDelete) {
                                deleteArticle();
                            }
                        }}
                    >
                        Supprimer
                    </button>

                )}
            </div>


            {open &&
                <Modal isOpen={open} onClose={handleClose}>
                    <center>
                        <div className='flex flex-col gap-4 items-center justify-center'>
                            {isDone ? (
                                <>
                                    <BsCheck2Circle className='text-green-700 text-[50px]' />

                                    <p>L'article a été supprimé !</p>
                                </>
                            ) : (
                                <>
                                    <MdOutlineSmsFailed className='text-red-700 text-[50px]' />

                                    <p>Une erreur s'est produite, veuillez réessayer !</p>
                                </>
                            )}
                            <button
                                className='buttonviolet w-[50px!important]'
                                type='submit'
                                onClick={handleClose}
                            >OK</button>
                        </div>
                    </center>
                </Modal>
            }
        </div>
    )
}

export default BlogArticleView